import React from 'react';

import { Button as AntdButton } from 'antd';

import { DossierResponseDto } from 'lib_api/lib/api/gen';

import { useDossierContext } from 'hooks/dossiers/DossierContext';
import { extractNonnullDossierIdOrThrow } from 'utils/dossierUtils';

import { useSubmitIdentifiabiliteProprietaire } from './utils';

import './ConfirmerNonIdentifiabiliteProprietaire.less';

interface ConfirmerNonIdentifiabiliteProprietaireProps {
  closeModal: () => void;
}

export const ConfirmerNonIdentifiabiliteProprietaire = ({
  closeModal,
}: ConfirmerNonIdentifiabiliteProprietaireProps): React.ReactElement => {
  const [{ result: dossier, setDossier }] = useDossierContext();
  const dossierId = extractNonnullDossierIdOrThrow(dossier);

  const [submit, submitInProgress] = useSubmitIdentifiabiliteProprietaire(
    dossierId,
    (updatedDossier: DossierResponseDto) => {
      setDossier(updatedDossier);
    },
    closeModal,
  );

  return (
    <div className="identifiabiliteProprietaireModal">
      <h3>Renseigner que le propriétaire n&apos;est pas identifiable</h3>
      <p>
        En confirmant que le propriétaire du véhicule n’est pas identifiable, le
        véhicule sera vendu ou détruit en cas d’abandon par son propriétaire
      </p>

      <div className="buttonsContainer">
        <AntdButton onClick={close}>Annuler</AntdButton>
        <AntdButton type="primary" disabled={submitInProgress} onClick={submit}>
          Confirmer
        </AntdButton>
      </div>
    </div>
  );
};
